import React, { Suspense, lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import { useWorkspacePrefetch } from './useWorkspacePrefetch';
import { LoadingState } from '@components/marble/States';

const PropertyHomePage = lazy(() => import('./pages/PropertyHomePage'));
const MarketPage = lazy(() => import('./pages/MarketPage'));
const CompetitorPage = lazy(() => import('./pages/CompetitorPage'));
const PropertyProfilePage = lazy(() => import('./pages/PropertyProfilePage'));
const PropertySetupPage = lazy(() => import('./pages/PropertySetupPage'));
const SeriesListPage = lazy(() => import('./pages/SeriesListPage'));
const SeriesPage = lazy(() => import('./pages/SeriesPage'));

/** `/property/*`: the organization's property, which is the workspace. */
const Workspace: React.FC = () => {
  useWorkspacePrefetch();
  return (
    <Suspense fallback={<LoadingState title="Opening your workspace…" />}>
      <Routes>
        <Route index element={<PropertyHomePage />} />
        <Route path="series" element={<SeriesListPage />} />
        <Route path="series/:seriesId" element={<SeriesPage />} />
        <Route path="market" element={<MarketPage />} />
        <Route
          path="market/competitors/:channelId"
          element={<CompetitorPage />}
        />
        <Route path="profile" element={<PropertyProfilePage />} />
        <Route path="setup" element={<PropertySetupPage />} />
      </Routes>
    </Suspense>
  );
};

export default Workspace;
